var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#1D1D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.24C8 6.10745 8.10745 6 8.24 6H10.76C10.8925 6 11 6.10745 11 6.24V8.76C11 8.89255 11.1075 9 11.24 9H16.76C16.8925 9 17 9.10745 17 9.24V11.76C17 11.8925 16.8925 12 16.76 12H11.24C11.1075 12 11 12.1075 11 12.24V14.76C11 14.8925 11.1075 15 11.24 15H16.76C16.8925 15 17 15.1075 17 15.24V17.76C17 17.8925 16.8925 18 16.76 18H8.24C8.10745 18 8 17.8925 8 17.76V6.24Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.741571cc3550cbe625758484a24f1d23.svg";
export { ForwardRef as ReactComponent };